import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  getAuthToken() {
    // mocked token for now
    if (environment.mockToken !== '') {
      return environment.mockToken;
    }
    return this.getToken();
  }

  // fix: previous key is  authToken, new key is exchange-id
  // renaming for chekcmarx security vulnerability
  getToken() {
    return window.localStorage.getItem('exchange-id');
  }

  setToken(id) {
    return window.localStorage.setItem('exchange-id', id);
  }

  deleteToken() {
    return window.localStorage.removeItem('exchange-id');
  }

  getLastUrl() {
    return window.localStorage.getItem('lastUrl') || '';
  }

  setLastUrl(url: string, pathname: string = null): void {
    let userLocale = null;
    if (pathname) {
      // INFO: DeepLinking functionality
      userLocale = this.getLocaleFromUrl(pathname);
      url = `/${userLocale}${url}`;
    }
    return window.localStorage.setItem('lastUrl', url);
  }

  getLoginUrl() {
    return environment.ssoLoginUrl + '?next=' +
      encodeURIComponent(environment.ssoCallbackUrl);
  }

  redirectToLoginUrl() {
    window.location.href = this.getLoginUrl();
  }

  getPort() {
    return window.localStorage.getItem('port');
  }

  setPort(port) {
    return window.localStorage.setItem('port', port);
  }

  getLocaleFromUrl(url: string) {
    return url.split('/')[1];
  }

  setPreviousURL(url: string): void {
    window.localStorage.setItem('previousURL', url);
  }

  getPreviousURL(): string {
    return window.localStorage.getItem('previousURL') || '';
  }

}
